import { ISuggest, OptionType } from 'components/common/Selects/MultiValueSelect/multiValuesSelect';
import { Logic } from '../../components/common/Selects/MultiValueSelect/components/MultiSelectWithConditions/MultiSelectWithConditions';
import { CriteriasType } from '../search/search.types';

export enum MarkupPages {
	Dicts = 'dicts',
	Tags = 'tags',
	Checklists = 'checklists',
	Gpt = 'gpt',
}

export type GroupType = 'dicts' | 'tags';

export type Action = 'clone' | 'enable' | 'disable' | 'delete' | 'make_global' | 'retag';

export type DictType = 'ordinary' | 'autoreplace' | 'grammar' | 'grammar_rule';

export type Group = {
	id?: string;
	owner?: string;
	title?: string;
	enabled?: boolean;
	enabledCount?: number;
	totalCount?: number;
};

export type UsedItem = {
	id: string;
	title: string;
	group: string;
	enabled: boolean;
	updateTime: string;
};

export type Item = {
	id: string;
	owner?: string;
	title: string;
	group: string;
	calculatedRulePriority?: string;
	enabled: boolean;
	usedRules?: UsedItem[];
	usedDicts?: UsedItem[];
	addTime: string;
	updateTime: string;
};

export type Dict = {
	id: string;
	owner: string | null;
	title: string;
	enabled: boolean;
	enabledCount: number;
	totalCount: number;
	allowedActions: string[];
	allowedUsers: string[] | [];
	usedRules: UsedItem[];
	phrases: string[] | [];
	group: string;
	groupTitle: string;
	type: DictType;
};

interface GlobalFilterBase {
	key: string;
	logic?: Logic;
	conditionItemId?: number | string | undefined;
}

export interface GlobalFilter extends GlobalFilterBase {
	values: string[];
}

export interface GlobalFilterComplex extends GlobalFilterBase {
	complexValues?: ISuggest[];
}

export type GlobalFilterIntersection = GlobalFilter & GlobalFilterComplex;

export type GlobalFilterCriteria = GlobalFilterIntersection & Partial<CriteriasType>;

export type FragmentType = {
	phrasesAndDicts: string[];
	phrases: string[];
	dicts: string[];
	direction: string;
	fromStart: boolean;
	silentBefore: string;
	silentAfter: string;
	interruptTime: string;
	talkBefore: string;
	talkAfter: string;
	onlyFirstMatch: boolean;
	fragmentsBefore: string;
	fragmentsAfter: string;
	distancePrevRuleTime: string;
	distancePrevRuleFragmentCount: string;
	orPhrasesAndDicts: string[];
	orPhrases: string[];
	orDicts: string[];
	orDirection: string;
	[key: string]: any;
};

export type SetTagsType = {
	name: string;
	value?: string;
};

export type TimeTagRulesType = {
	interval: string;
	beforeTags: string[];
	afterTags: string[];
	checkNotExist: boolean;
	reverseLogic: boolean;
};

export type TagRuleType = {
	id?: string;
	owner: string;
	title: string;
	group?: string;
	enabled: boolean;
	calculatedRulePriority: number;
	globalFilter: GlobalFilterCriteria[];
	fragmentRules: FragmentType[];
	setTags: SetTagsType[];
	allowedActions: string[];
	timeTagRules: TimeTagRulesType[];
	entityType: 'CALL' | 'DEAL';
};

export interface TagRuleTypeResponse extends Omit<TagRuleType, 'globalFilter'> {
	globalFilter: (GlobalFilter | GlobalFilterComplex)[];
}

export type DictsStateType = {
	groups: (Group | null)[];
	ownerGroups: (Group | null)[];
	groupsBlock: boolean;
	groupsOwnerBlock: boolean;
	currentGroup: Group | null;
	currentOwnerGroup: Group | null;
	dicts: (Item | null)[] | null;
	ownerDicts: (Item | null)[] | null;
	currentDict: Dict | null | false;
	currentOwnerDict: Dict | null | false;
	sort: { sort: string; sort_desc: boolean };
	ownerSort: { sort: string; sort_desc: boolean };
};

export type TagsStateType = {
	groups: (Group | null)[];
	ownerGroups: (Group | null)[];
	groupsBlock: boolean;
	groupsOwnerBlock: boolean;
	currentGroup: Group | null;
	currentOwnerGroup: Group | null;
	tags: (Item | null)[] | null;
	ownerTags: (Item | null)[] | null;
	currentTag: TagRuleType | null | false;
	currentOwnerTag: TagRuleType | null | false;
	sort: { sort: string; sort_desc: boolean };
	ownerSort: { sort: string; sort_desc: boolean };
};

export type InitialState = {
	page: GroupType | string;
	ownerPage: GroupType | string;
	activeDicts: string[];
	dicts: DictsStateType;
	tags: TagsStateType;
	copyMode: boolean;
	copyModeSuccess: boolean;
	ownerGroupsAndItemsLoading: boolean;
	rulesOwner: OptionType;
	usersOnlyListForSelect: OptionType[];
	fragments: FragmentType[];
	tagsIsLoading: boolean;
	dictsIsLoading: boolean;
};

export type MR<Data> = {
	page: GroupType | string;
	data: Data;
	complexCriteria?: CriteriasType;
	rule_owner?: string;
};

export type GetItemsMR = MR<{ sort: string; sort_desc: boolean; filter?: string; group?: string }>;

export interface MROwner<Data> extends MR<Data> {
	rule_owner: string;
}
